import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["value"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Icon = _resolveComponent("Icon");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass('input-group input-group-sm mb-' + _ctx.mb)
    }, [
        _createElementVNode("span", {
            class: "input-group-text",
            id: "basic-addon1",
            onClick: _cache[0] || (_cache[0] =
                //@ts-ignore
                (...args) => (_ctx.onIconClick && _ctx.onIconClick(...args))),
            style: _normalizeStyle(_ctx.iconStyle)
        }, [
            (_ctx.currentValue === '')
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 0,
                    style: { "color": "#212529" },
                    icon: ['fas', 'magnifying-glass']
                }))
                : (_openBlock(), _createBlock(_component_Icon, {
                    key: 1,
                    style: { "color": "#212529" },
                    icon: ['fas', 'xmark']
                }))
        ], 4),
        _createElementVNode("input", {
            type: "text",
            class: "form-control",
            value: _ctx.currentValue,
            onInput: _cache[1] || (_cache[1] =
                //@ts-ignore
                (...args) => (_ctx.onInput && _ctx.onInput(...args))),
            onKeydown: _cache[2] || (_cache[2] =
                //@ts-ignore
                (...args) => (_ctx.onKeypress && _ctx.onKeypress(...args)))
        }, null, 40, _hoisted_1)
    ], 2));
}
